export enum ResourceLoaderCacheLevel {
  FetchCache = 'fetch-cache',
  Memory = 'memory',
  Idb = 'idb',
}
